/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_Sound_PlaceholderInputs */

const en_pronunciation_report_sound_placeholder = /** @type {(inputs: Pronunciation_Report_Sound_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For example: TUR-moyl`)
};

const es_pronunciation_report_sound_placeholder = /** @type {(inputs: Pronunciation_Report_Sound_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por ejemplo: TUR-moyl`)
};

/**
* | output |
* | --- |
* | "For example: TUR-moyl" |
*
* @param {Pronunciation_Report_Sound_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_sound_placeholder = /** @type {((inputs?: Pronunciation_Report_Sound_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_Sound_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_sound_placeholder(inputs)
	return en_pronunciation_report_sound_placeholder(inputs)
});